<video #media id="aboutVideo" class="w-100 rounded" preload="auto" crossorigin="true"
  poster="assets/images/staff/staff.webp" controls>
  <source src="assets/videos/about-us.mp4" type="video/mp4" />
</video>